import { useToasts } from '../../hooks/useToast'

export function ToastHost() {
  const toasts = useToasts()
  if (toasts.length === 0) return null

  return (
    <div className="toastwrap" role="status" aria-live="polite">
      {toasts.map(t => (
        <div key={t.id} className="toast">
          <span className="tdot" aria-hidden="true" />
          {t.message}
        </div>
      ))}
    </div>
  )
}
